import React from 'react';
import { NavLink, Outlet } from 'react-router-dom';
import Navbar from '../../components/Navbar';
import PlatformFooter from '../../components/PlatformFooter';
import { useAuth } from '../../context/AuthContext';

// Genpop shell — authenticated user with no active memberships.
// Primary action: find a community to join or check existing pending claim.
// Nav is minimal; the main content area does the heavy lifting.
const GenpopShell = () => {
  const { memberships } = useAuth();

  // memberships array here only contains active records (from bootstrap).
  // If genpop, it's empty — but we may still have pending claims (shown in dashboard).
  const hasPending = memberships.length === 0;

  return (
    <div className="shell shell--genpop">
      <Navbar />
      {hasPending && (
        <div className="shell-genpop-notice" role="status">
          Your community membership is pending review. Once verified, you'll have full access.
        </div>
      )}
      <div className="shell-body">
        <nav className="shell-sidenav" aria-label="Navigation">
          <span className="shell-sidenav__heading">Civic Intelligence</span>
          <ul>
            <li>
              <NavLink
                to="/dashboard"
                className={({ isActive }) =>
                  isActive ? 'shell-sidenav__link shell-sidenav__link--active' : 'shell-sidenav__link'
                }
              >
                Home
              </NavLink>
            </li>
            <li>
              <NavLink
                to="/membership"
                className={({ isActive }) =>
                  isActive ? 'shell-sidenav__link shell-sidenav__link--active' : 'shell-sidenav__link'
                }
              >
                Join a Community
              </NavLink>
            </li>
          </ul>
        </nav>
        <main className="shell-content">
          <Outlet />
        </main>
      </div>
      <PlatformFooter />
    </div>
  );
};

export default GenpopShell;
